<ng-container *ngIf="!simpleFooter">
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12 footer__row-higher">
          <img class="footer__image" [src]="footerLogoPath" [alt]="appName">
          <div class="footer__links">
            <ul>
              <li *ngFor="let link of footerLinks">
                <a [core-analytics]="{action: link.text, category: 'FOOTER'}" [href]="link.url" [innerText]="link.text"
                   [target]="link.target ?? '_self'"></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-12 px-0 footer__row-lower">
          <div class="footer__links-lower">
            <ul>
              <li *ngFor="let link of footerLinksLower">
                <a [core-analytics]="{action: link.text, category: 'FOOTER'}" [href]="link.url" [innerText]="link.text"
                   [target]="link.target ?? '_self'"></a>
              </li>
              <li [innerHtml]="copyright"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="simpleFooter">
  <div class="footer footer--simple">
    <div class="container">
      <div class="row">
        <div class="col-md-12 footer--simple__row">
          <img class="footer__image" [src]="logo" [alt]="appName">
        </div>
      </div>
    </div>
  </div>
</ng-container>
